export default __webpack_public_path__ + "static/media/wi.7914c8ae.png";